import CommunicationsWorkspace, {
  CommunicationClient,
} from '@/modules/admin-dashboard/components/communications/CommunicationsWorkspace.tsx';

interface ClientCommunicationsTabProps {
  client: CommunicationClient;
}

export const ClientCommunicationsTab = ({ client }: ClientCommunicationsTabProps) => {
  return <CommunicationsWorkspace client={client} />;
};

export default ClientCommunicationsTab;
